module.exports = __webpack_public_path__ + "img/humanResource.135d5899.svg";